import { useState } from "react";
import { motion } from "framer-motion";
import { Flame } from "lucide-react";

const LOGO = "/brand/logo.jpeg";

export default function AgeGate({ onVerify }) {
  const [denied, setDenied] = useState(false);

  return (
    <motion.div
      data-testid="age-gate"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="fixed inset-0 z-[100] flex items-center justify-center bg-ink/95 backdrop-blur-2xl px-6"
    >
      <div className="ember-glow absolute inset-0 pointer-events-none opacity-60" aria-hidden="true" />
      <motion.div
        initial={{ y: 40, opacity: 0, scale: 0.98 }}
        animate={{ y: 0, opacity: 1, scale: 1 }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        className="relative w-full max-w-lg border border-surface-border bg-surface/80 p-8 sm:p-12 text-center"
      >
        <img src={LOGO} alt="Hot Packz Grabba logo" className="mx-auto mb-8 w-44 sm:w-52 animate-flicker" />

        {!denied ? (
          <>
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-blaze mb-4">
              Age Verification
            </p>
            <h1 className="font-display text-4xl sm:text-5xl uppercase leading-none mb-4">
              Are you <span className="text-fire">21</span> or older?
            </h1>
            <p className="text-muted-foreground text-sm sm:text-base mb-9 max-w-sm mx-auto">
              This site contains information about tobacco products. You must be of
              legal age to enter.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <button
                data-testid="age-gate-confirm"
                onClick={onVerify}
                className="group flex-1 inline-flex items-center justify-center gap-2 bg-blaze text-white font-heading uppercase text-sm tracking-wider py-4 px-6 transition-colors duration-200 hover:bg-gold hover:text-ink"
              >
                <Flame size={18} className="transition-transform duration-200 group-hover:scale-110" />
                Yes, I'm 21+
              </button>
              <button
                data-testid="age-gate-deny"
                onClick={() => setDenied(true)}
                className="flex-1 border border-surface-border text-muted-foreground font-heading uppercase text-sm tracking-wider py-4 px-6 transition-colors duration-200 hover:border-blaze hover:text-white"
              >
                No, exit
              </button>
            </div>
          </>
        ) : (
          <div data-testid="age-gate-denied">
            <h1 className="font-display text-3xl sm:text-4xl uppercase leading-none mb-4 text-fire">
              Access Denied
            </h1>
            <p className="text-muted-foreground text-sm sm:text-base mb-8">
              You must be 21 or older to view this content. Please come back when
              you're of legal age.
            </p>
            <button
              onClick={() => setDenied(false)}
              className="font-mono text-xs uppercase tracking-[0.25em] text-blaze underline underline-offset-4"
            >
              Go back
            </button>
          </div>
        )}

        <p className="mt-9 text-[11px] leading-relaxed text-muted-foreground/70">
          WARNING: This product contains nicotine. Nicotine is an addictive chemical.
        </p>
      </motion.div>
    </motion.div>
  );
}
